const FleetsConfig = {
  collection: "fleets",
  single: true,
  fields: [
    "id",
    "date_updated",
    "header_competitor",
    "add_label",
    "edit_label",
    "brand_label",
    "brand_placeholder",
    "model_label",
    "model_placeholder",
    "quantity_label",
    "quantity_placeholder",
    "monthly_avg_label",
    "monthly_avg_placeholder",
    "total_mpv_label",
    "total_label",
    "add_another_model_label",
    "monthly_avg_note",
    "monthly_avg_tooltip"
  ],

  adapter: class Fleets {
    constructor(fleet) {
      Object.assign(this, fleet);
    }
  }
};

export default FleetsConfig;
